/**
 * This file helps keep output size down by aliasing properties that are used often.
 */
export const activationStart = "activationStart";
export const duration = "duration";
export const entryType = "entryType";
export const length = "length";
export const name = "name";
export const navigationStart = "navigationStart";
export const push = "push";
export const processingEnd = "processingEnd";
export const processingStart = "processingStart";
export const processingTime = "processingTime";
export const script = "script";
export const selector = "selector";
export const startTime = "startTime";
export const totalDuration = "totalDuration";
